export default "__VITE_ASSET__Ce2trrQO__"